import {
  CrowPayLegalDocumentvhqnf9xycsrg as CrowPayLegalDocument,
  LegalDocumentAgreement2jq7u4nlw18u as LegalDocumentAgreement,
} from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_type2gdsz5zh8ip2m as get_type,
  get_establishedAt34uuc9xf75ez9 as get_establishedAt,
} from '../../../../crowpay-shared/com/crowpay/CrowPayLegalDocumentFields.mjs';
import {
  eq1298m2cje971u as eq,
  lte255n7t6e9er47 as lte,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../sdk/apiOptions.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../selectedContractor.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  get_contractor1xz81jdndzal8 as get_contractor,
  get_user1oq3bclwp0mza as get_user,
  get_documentr6hzirewxd26 as get_document,
  get_accessInfo34u27j9iv1ssd as get_accessInfo,
} from '../../../../crowpay-shared/com/crowpay/LegalDocumentAgreementFields.mjs';
import { get_timestamp2nq1ys1aq8dif as get_timestamp } from '../../../../crowpay-shared/com/crowpay/AccessInfoFields.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(CrowPayLegalDocument()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp0_condition = and(eq(get_type(it), $this.yfy_1.tfy_1), lte(get_establishedAt(it), $this.yfy_1.ufy_1));
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CrowPayLegalDocument()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  this_0.n4a(get_establishedAt(it_0));
  var tmp1_orderBy = this_0.o1r();
  var query = new (Query())(tmp0_condition, tmp1_orderBy, VOID, 1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_rawSession();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp2_safe_receiver = tmp_1;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = tmp2_safe_receiver.ffv_1.feo(query);
    var tmp_3 = await_0(this_2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp$ret$12 = tmp_3;
    return firstOrNull(tmp$ret$12);
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_selectedApi();
    var tmp_5 = await_1(this_3, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var tmp_6 = tmp_5.bfx().pff_1.kfj(query, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_4 = firstOrNull(tmp_6);
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  return tmp_4;
}
function *_generator_invoke__zhh2q8_0($this, $this$withWrite, agreed, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.zfy_1.vfy_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = tmp_0;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a5v_1;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var document = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.zfy_1.wfy_1;
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp2_safe_receiver = tmp_2;
  var currentAgreement = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s6d_1;
  if (agreed && currentAgreement == null) {
    var tmp_3 = session.ufw();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_selectedContractor();
    var tmp_4 = await_1(this_3, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp$ret$3 = tmp_4;
    var tmp_5 = session.gfv_1.zen(new (LegalDocumentAgreement())(VOID, tmp_3, tmp$ret$3, document), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  } else if (!agreed && !(currentAgreement == null)) {
    var tmp_6 = session.gfv_1.eeo(currentAgreement).iem($completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
  }
  return Unit_instance;
}
function *_generator_accept__gepchs($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vfy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a5v_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    throw PlainTextException().jcw('No document for ' + $this.tfy_1.e91_1 + ' found');
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var document = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp_2 = session.ufw();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_selectedContractor();
  var tmp_3 = await_1(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp$ret$2 = tmp_3;
  var tmp_4 = session.gfv_1.zen(new (LegalDocumentAgreement())(VOID, tmp_2, tmp$ret$2, document), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return tmp_4;
}
var AgreementData$mostRecentVersion$slambdaClass;
function AgreementData$mostRecentVersion$slambda() {
  if (AgreementData$mostRecentVersion$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.yfy_1 = this$0;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AgreementData$mostRecentVersion$slambdaClass = $;
  }
  return AgreementData$mostRecentVersion$slambdaClass;
}
function AgreementData$mostRecentVersion$slambda_0(this$0) {
  var i = new (AgreementData$mostRecentVersion$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function AgreementData$acceptedLatestVersion$lambda(it) {
  return !(it == null);
}
var AgreementData$acceptedLatestVersion$slambdaClass;
function AgreementData$acceptedLatestVersion$slambda() {
  if (AgreementData$acceptedLatestVersion$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.zfy_1 = this$0;
      }
      afz($this$withWrite, agreed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withWrite, agreed), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    AgreementData$acceptedLatestVersion$slambdaClass = $;
  }
  return AgreementData$acceptedLatestVersion$slambdaClass;
}
function AgreementData$acceptedLatestVersion$slambda_0(this$0) {
  var i = new (AgreementData$acceptedLatestVersion$slambda())(this$0);
  var l = ($this$withWrite, agreed, $completion) => i.afz($this$withWrite, agreed, $completion);
  l.$arity = 2;
  return l;
}
var AgreementDataClass;
function AgreementData() {
  if (AgreementDataClass === VOID) {
    class $ {
      constructor(type) {
        this.tfy_1 = type;
        this.ufy_1 = System_instance.d1m();
        var tmp = this;
        tmp.vfy_1 = rememberSuspending(VOID, VOID, VOID, AgreementData$mostRecentVersion$slambda_0(this));
        var tmp_0 = this;
        tmp_0.wfy_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.baj(get_rawSession());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var session = tmp;
          var tmp1_elvis_lhs = $this$remember.baj(this.vfy_1);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            return null;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var document = tmp_0;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(LegalDocumentAgreement()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var agreement = new (DataClassPathSelf())(tmp$ret$0);
          var tmp0_safe_receiver = $this$remember.baj(get_selectedContractor());
          var tmp_2;
          if (tmp0_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_2 = eq(get_contractor(agreement), tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs_0 = tmp_2;
          var tmp2_condition = and(tmp1_elvis_lhs_0 == null ? eq(get_user(agreement), session.efv_1) : tmp1_elvis_lhs_0, eq(get_document(agreement), document.a5v_1));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(LegalDocumentAgreement()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$7);
          this_0.n4a(get_timestamp(get_accessInfo(it)));
          var tmp3_orderBy = this_0.o1r();
          return firstOrNull($this$remember.baj(session.gfv_1.feo(new (Query())(tmp2_condition, tmp3_orderBy, VOID, 1))));
        });
        var tmp_1 = this;
        var tmp_2 = lens(this.wfy_1, AgreementData$acceptedLatestVersion$lambda);
        tmp_1.xfy_1 = withWrite(tmp_2, AgreementData$acceptedLatestVersion$slambda_0(this));
      }
      bfz($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_accept__gepchs.bind(VOID, this), $completion);
      }
      toString() {
        return 'AgreementData(type=' + toString(this.tfy_1) + ')';
      }
      hashCode() {
        return this.tfy_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AgreementData()))
          return false;
        if (!this.tfy_1.equals(other.tfy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AgreementData', VOID, VOID, VOID, [0]);
    AgreementDataClass = $;
  }
  return AgreementDataClass;
}
//region block: exports
export {
  AgreementData as AgreementData1bovrwm0h7gbm,
};
//endregion

//# sourceMappingURL=AgreementData.mjs.map
